//store 
import * as PaymentStore from "../../../../redux/middleware/CashFlow-Payments.Middlerware";

// models
import { Payment } from "../../../../models/Entities/CashFlow/Payment/Payment";
import { ErrorType } from "../../../../models/HttpError";
import { AppState } from "../../../../redux/reducers";
import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

import * as jwt_decode from "jwt-decode";
import { Person } from "../../../../models/Entities/Person/Person";

// form types
export enum FormType {
  payer =1,
  receiver = 2
}

//#region Props

interface IProps {
    FormType: FormType;
    ReferalId: string | undefined;
    FixedAssociatedEntityIdentifier: string | undefined;
    PaymentId?: number;
    isOpen: boolean;
    onClose: () => void;
  }
  
  interface ConnectedProps {
    isLoading: boolean;
    isLoadingSuccessfully: boolean;
    failOnLoading: boolean;

    isSaving: boolean;
    isSaved: boolean | undefined;
    failOnSaving: boolean;

    DefaultPayer: Person | undefined;
    DeFaultReceiver: Person | undefined;

    error: ErrorType | undefined;
    CurrentPayment: Payment;
    OwnerId: string;
    Persons: Person[];

    // methods
    GetPersonByIdentifier: (identifier: string) => Person | undefined;
  }
  
  interface MedicalServicesDispatchProps {
    GetPaymentById: typeof PaymentStore.actionCreators.GetPaymentById;
    CreatePayment: typeof PaymentStore.actionCreators.CreatePayment;
    UpdatePayment: typeof PaymentStore.actionCreators.UpdatePayment;
  }
  
  export type Props = IProps & ConnectedProps & MedicalServicesDispatchProps;
  
  export const mapStateToProps = (state: AppState, ownProps: IProps) => {

    var currentPayment = ownProps.PaymentId ? ownProps.FormType === FormType.payer ? state?.CashFlowPayments?.paymentsDone?.find((payment: Payment) => payment.id === ownProps.PaymentId) 
     : state?.CashFlowPayments?.paymentsReceived?.find((payment: Payment) => payment.id === ownProps.PaymentId) 
     : null ;

    const currentOwner: string = (jwt_decode.jwtDecode(state?.oidc?.user?.access_token!) as any)?.tenantId;

    if(ownProps.PaymentId && !currentPayment){
        PaymentStore.actionCreators.GetPaymentById(ownProps.PaymentId);
    }

    // person who represnets the medical center
    const ownerPerson: Person = {
      personIdentifier: currentOwner,
      id: 0,
      isDeleted: false,
      personType: 0,
      businessName: "Centro Médico"
    };

    const propsPayer = ownProps.FormType === FormType.payer 
    ? ownProps.ReferalId && ownProps.ReferalId === currentOwner 
      ? ownerPerson
      : GetPersonByIdentifier(state.Persons?.list || [], currentOwner, ownProps.ReferalId || '')
    : GetPersonByIdentifier(state.Persons?.list || [], currentOwner, ownProps.FixedAssociatedEntityIdentifier || '');

    const propsReceiver = ownProps.FormType === FormType.receiver
    ? ownProps.ReferalId && ownProps.ReferalId === currentOwner 
      ? ownerPerson
      : GetPersonByIdentifier(state.Persons?.list || [], currentOwner, ownProps.ReferalId || '')
    : GetPersonByIdentifier(state.Persons?.list || [], currentOwner, ownProps.FixedAssociatedEntityIdentifier || '');

    
    return ({
        isLoading: state.CashFlowPayments?.isLoadingOne,
        isLoadingSuccessfully: state.CashFlowPayments?.successLoadingOne,
        failOnLoading: state.CashFlowPayments?.failOnLoadingOne,
        
        isSaving: currentPayment ? (currentPayment.isUpdating || currentPayment.isSaving) : state.CashFlowPayments?.isAddingNewOne || false,
        isSaved: currentPayment ? (currentPayment.isUpdatedSuccessfully || currentPayment.isSavedSuccessfully) : state.CashFlowPayments?.successAddingNewOne || undefined,
        failOnSaving: currentPayment ? (currentPayment.failOnUpdating || currentPayment.failOnSaving) : state.CashFlowPayments?.failOnAddingNewOne || false,

        DefaultPayer: propsPayer,
        DeFaultReceiver: propsReceiver,
        
        error: state.CashFlowPayments?.error || currentPayment?.error || undefined,
        CurrentPayment: currentPayment,
        OwnerId: currentOwner,
        Persons: state.Persons?.list || [],
        GetPersonByIdentifier: (identifier: string) => GetPersonByIdentifier(state.Persons?.list || [], currentOwner, identifier)
    })
  };
  
  export const mapDispatchToProps = {
    ...PaymentStore.actionCreators
  };


  // styles
  export const useStyles = makeStyles({
    formField: {
        display: "flex",
        flexDirection: "column",
        gap: "2px",
        maxWidth: "400px",
      },
    content: {
      display: "flex",
      flexDirection: "column",
      rowGap: tokens.spacingVerticalL,
      width: "100%",
      boxSizing: "border-box",
    },
    sectionCard: {
      ...shorthands.borderRadius(tokens.borderRadiusMedium),
      ...shorthands.border("1px", "solid", tokens.colorNeutralStroke2),
      ...shorthands.padding(tokens.spacingVerticalM, tokens.spacingHorizontalL),
      backgroundColor: tokens.colorNeutralBackground2,
      display: "flex",
      flexDirection: "column",
      rowGap: tokens.spacingVerticalM,
    },
    sectionTitle: {
      fontSize: tokens.fontSizeBase200,
      fontWeight: tokens.fontWeightSemibold,
      color: tokens.colorNeutralForeground3,
      lineHeight: tokens.lineHeightBase200,
      textTransform: "uppercase",
      letterSpacing: "0.05em",
    },
    row: {
      display: "grid",
      gridTemplateColumns: "minmax(150px, 200px) minmax(0, 1fr)",
      columnGap: tokens.spacingHorizontalM,
      rowGap: tokens.spacingVerticalS,
      alignItems: "start",
      width: "100%",
    },
    currencyCol: {
      minWidth: 0,
      // El Dropdown de Fluent trae un min-width interno (~250px) que desborda la columna;
      // lo forzamos a ocupar el ancho disponible para evitar superposición con el monto.
      "& .fui-Dropdown": {
        minWidth: "unset",
        width: "100%",
      },
    },
    amountCol: {
      minWidth: 0,
    },
    amountHint: {
      color: tokens.colorNeutralForeground3,
      fontSize: tokens.fontSizeBase200,
      lineHeight: tokens.lineHeightBase200,
      marginTop: tokens.spacingVerticalXXS,
      display: "block",
    },
    footerActions: {
      display: "flex",
      justifyContent: "flex-end",
      columnGap: tokens.spacingHorizontalS,
    },
  });

// functions
export const GetPersonByIdentifier = (persons: Person[], tenantId: string, identifier: string): Person | undefined => {
   
    if(identifier === tenantId) return {
        personIdentifier: tenantId,
        businessName: 'Centro Médico'
    } as Person;
    return persons.find((person: Person) => person.personIdentifier === identifier);
}
